import React, { useState, useEffect } from "react";
import TableSearch from "./TableSearch";
import TablePagination from "./TablePagination";

import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { getInitialColumnVisibility } from "../../../utils/options";
import { useLocation } from "react-router-dom";
const Table = ({
  columns,
  data,
  serverSide = false, // automatically toggle between server/client pagination
  currentPage,
  lastPage,
  onPageChange, // required if serverSide=true
}) => {
  const location=useLocation()
  const pathname=location.pathname
  let fileName=(pathname.split("/")[2]|| "List")?.replace(/-/g," ")?.trim()
  const [globalFilter, setGlobalFilter] = useState("");
  const [columnVisibility, setColumnVisibility] = useState(() =>
    getInitialColumnVisibility(columns)
  );

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const table = useReactTable({
    data,
    columns,
    state: {
      columnVisibility,
      globalFilter,
      pagination,
    },
    onColumnVisibilityChange: setColumnVisibility,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    onGlobalFilterChange: setGlobalFilter,
    getPaginationRowModel: !serverSide ? getPaginationRowModel() : undefined,
    onPaginationChange: !serverSide ? setPagination : undefined,
  });

  return (
    <div className="col-12 fw-semibold">
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body p-0">
        
          <div
                  className="card-header py-3"
                  style={{ backgroundColor: "#0e606e" }}
                >
                  <h5 className="mb-0 text-white text-capitalize">
                  {fileName}
                  </h5>
                </div>
                  {/* Search and Export */}
          <div className="card-body ">
            <TableSearch
              table={table}
              setGlobalFilter={setGlobalFilter}
              globalFilter={globalFilter}
              setColumnVisibility={setColumnVisibility}
              pdfTitle={data[0]?.title ?? "Exported Data"}
            />
          </div>
          {/* Responsive Table */}
          <div className="table-responsive mt-0">
            <table className="table table-hover align-middle mb-0">
              <thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id}>
                    <th style={{ width: "72px" }}>S. No</th>
                    {headerGroup.headers.map((header) => (
                      <th
                        key={header.id}
                        className={
                          header.column.columnDef.meta?.headerClassName
                        }
                      >
                        <ArrowToggle header={header}>
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                        </ArrowToggle>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody>
                {table.getRowModel().rows.map((row, idx) => (
                  <tr key={row.id} className="align-middle">
                   <td>
  {serverSide
    ? (currentPage - 1) * table.getState().pagination.pageSize + idx + 1
    : row.index + 1}
</td>

                    {row.getVisibleCells().map((cell) => (
                      <td
                        key={cell.id}
                        className={cell.column.columnDef.meta?.className}
                        style={{ wordBreak: "break-word" }}
                      >
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {!serverSide ? (
            <TablePagination table={table} />
          ) : (
            <div className="d-flex justify-content-between align-items-center mt-2 mx-1 mb-1">
              <div>
                Page {currentPage} of {lastPage}
              </div>
              <ul className="pagination mb-0">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                  onClick={() =>
                    currentPage > 1 && onPageChange(currentPage - 1)
                  }
                >
                  <span className="page-link">Previous</span>
                </li>
                <li className="page-item active ">
                  <span className="page-link" style={{ backgroundColor: "" }}>
                    {currentPage}
                  </span>
                </li>
                <li
                  className={`page-item ${
                    currentPage === lastPage ? "disabled" : ""
                  }`}
                  onClick={() =>
                    currentPage < lastPage && onPageChange(currentPage + 1)
                  }
                >
                  <span className="page-link">Next</span>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Table;

// Arrow toggle component
const ArrowToggle = ({ header, children }) => {
  return (
    <div
      className="d-flex align-items-center"
      style={{
        cursor: header.column.getCanSort() ? "pointer" : "default",
        width: "max-content",
        color: "white",
      }}
      onClick={header.column.getToggleSortingHandler()}
    >
      {children}
    </div>
  );
};
